/****************************************************************
 * Js imports
 ****************************************************************/
/****************************************************************
 * CODE reorder
 ****************************************************************/
!(function ($, document, window, undefined) {

  /**
   * Plugin name
   */
  var _pluginName = 'reorder';

  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return reorder_plugin
   */
  var reorder_plugin = function ($element, options) {

    // Scope it
    var self = this;
    self.$element = $element;

    // Get options
    var defaults = {};
    var metaOptions = self.$element.data('reorder-button');
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log('Init reorder:', self.$element, self.options);
    }

    // Start the reorder
    self.init();
  };

  /**
   * Init
   *
   * @return void
   * @access public
   */
  reorder_plugin.prototype.init = function () {
    var self = this;

    // Catch click on button
    self.$element.on('click', function (event) {
      event.preventDefault();
      self.createReOrder();
    });
  };

  /**
   * create reorder
   *
   * @return void
   * @access public
   */
  reorder_plugin.prototype.createReOrder = function () {
    var self = this;
    var cartPlugin = $('body').data('plugin_cartEvents');

    // Show site loader
    $.siteLoader.show();

    // Get low stock items
    let lowStock = [ ...self.options.items ].map((item) => {
      if (parseInt(item.inventory_quantity) >= parseInt(item.quantity) || item.inventory_policy == "continue") {
        return;
      }
      return {
        ...item,
        "max_quantity": item.inventory_quantity
      };
    }).filter((item) => item);

    // fetch cart
    cartPlugin.fetchCart()
      .then(cart => {

        // Get weight group config
        let weightGroups = [ ...self.options.items ].map((item) => {
          let quantity = parseInt(item.quantity);
          // If low stock, add maximum

          if (parseInt(item.inventory_quantity) < parseInt(item.quantity) && item.inventory_policy == "deny") {
            quantity = item.inventory_quantity;
          }

          let newItem = cartPlugin.handleWeightTierProduct(item, quantity, cart);

          return newItem.updates;
        });


        // create new order
        let new_order = {}
        for (let group of weightGroups) {
          new_order = { ...new_order, ...group}
        }

        // debug
        if ($.code.debug) {
          console.log('New reorder', new_order, self.options.items);
        }

        // return order
        return cartPlugin.postUpdatesToCart({ updates: new_order });

      })
      .then(cart => {

        $.siteLoader.hide();

        // update max inventory quantity
        self.options.items = [...self.options.items].map((item) => {
          item.inventory_quantity = item.inventory_quantity - item.quantity;
          if (item.inventory_quantity < 0) {
            item.inventory_quantity = 0;
          }
          return item;
        });

        // Update cart icon with the new quantity
        cartPlugin.updateCartIcon(cart.item_count);

        // Show low stock message
        if (lowStock[0]) {
          self.lowStockMessage(lowStock);

          // Set the updated cart
          self.options.cart = cart;

        // Or redirect to cart
        } else {

          window.location.href = '/cart';
        }
      })
      .catch((error) => {
        if($.code.debug) {
          console.log(error);
        }
      })
      .then(function(){
        // Hide the loader again when something went wrong
        $.siteLoader.hide();
      });
  };


  /**
   * Message for when there is not enaugh stock of an item
   *
   * @return void
   * @access public
   */
  reorder_plugin.prototype.lowStockMessage = function (data) {

    // Create a message
    let messageTitle = theme.strings.reorderAddErrorTitle,
        messageString = theme.strings.reorderAddError;

    if (!messageString && !data) {
      return;
    }

    // Create message per product
    let message = [ ...data ].map((item) => {
      let title = `${item.product_title} ${item.title}`;
      return `<p>${messageString.replace('[title]', title).replace('[nr]', item.quantity).replace('[stock]', item.max_quantity)}</p>`;
    }).join('');

    // Show notification
    $.fancybox.open(`
      <div class="message">
        <h2>${messageTitle}</h2>
        ${message}
        <a href="${window.theme.routes.cart_url}" class="button button--primary">
          ${window.theme.strings.goToCart}
        </a>
      </div>`,
      {
        baseClass: "cart-notification cart-notification--update"
      }
    );

  };

  /**
   * reorder plugin
   *
   * @return jQuery objects
   */
  $.fn.reorder = function (options) {

    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // Initialize the items
    return this.each(function () {

      // Store the element the plugin is set on
      var $element = $(this);

      // Guard if plugin was already initted
      var instance = $element.data('plugin_' + _pluginName);

      // If plugin was not innited
      if (!instance) {

        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new reorder_plugin($element, options));
      } else {

        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };

})(jQuery, document, window);

/****************************************************************/

/****************************************************************
 * CODE init
 ****************************************************************/

$.code.accountInit = function () {

  // Init reorder
  $('[data-reorder-button]').reorder();

};

$.code.accountInit();